/**
 * Controller for [data-secondary-panel] — unlike other .dom.js files in this folder (whose
 * elements always exist and are just shown/hidden), this one creates the element itself, and
 * only when the caller actually asks for it: floorPlanDetail.plugin.js/housingUnitDetail.plugin.js
 * only call this factory on desktop, and only while their Floor Plan Configuration tab is active
 * (see their syncSecondaryPanel()), destroying it via remove() the rest of the time rather than
 * just hiding it. Both plugins can be mounted at once (one per detail view type), so a
 * merely-hidden-but-still-in-the-DOM panel from one would leave a second `[data-floor-plan-*]`
 * carousel + arrow set behind — and floorPlanCarousel.dom.js's global data-attribute selectors
 * assume only one ever exists (NHS20-8885). Destroying it is what actually makes that true.
 *
 * @module nativeInteractiveSiteMap/components/secondaryPanelController.dom
 */
import renderFloorPlanCarousel, { initializeFloorPlanCarousel } from './floorPlanCarousel.dom';

const ROOT_CLASS = 'nhs-u-absolute--cover nhs-u-background-color--white-100 nhs-u-z-index--content-secondary';

/**
 * @param {HTMLElement} containerElement - appended into immediately; the map's own sized,
 *   positioned container, so this panel's absolute positioning resolves against it.
 * @returns {{ show: Function, remove: Function }}
 */
export default function createSecondaryPanelController(containerElement) {
  const element = document.createElement('div');
  element.className = ROOT_CLASS;
  element.setAttribute('data-secondary-panel', '');
  element.setAttribute('data-qa', 'native_ism_secondary_panel');
  containerElement.appendChild(element);

  return {
    /**
     * @param {object} params
     * @param {object[]} [params.floorplans] - The selected plan's `floorplans` array, unsorted.
     */
    show({ floorplans }) {
      element.innerHTML = renderFloorPlanCarousel({ floorplans });
      initializeFloorPlanCarousel();
    },

    remove() {
      element.remove();
    },
  };
}
